<template>
  <div class="footer">
    <div class="footer-content">
      <copyRight></copyRight>
      <div class="logo">
        <router-link to="/"> </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import copyRight from "../../components/cpoyRight.vue";
export default {
  components: {
    copyRight
  },
}
</script>
<style lang="scss" scoped>
.footer {
  background: #606060;
}

.footer-content {
  //   height: 31px;
  width: 1000px;
  margin: auto;
  font-size: 0.16px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    margin: 5px;

    a {
      color: #fff;
    }
  }
}

.logo {
  a {
    width: 80px;
    height: 35px;
    background: url("../../assets/Hfootlogo.svg") no-repeat 50%/100%;
  }

  :hover {
    background: url("../../assets/footlogo.svg") no-repeat 50%/100%;
  }
}
</style>